import Cookies from "js-cookie";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Helmet } from "react-helmet";

interface Props {
  enableAbTesting?: boolean
}

const cookieCategory = "C0002";
const allowedCookies = `${cookieCategory}:1`;

export const OptimizelySnippet: FunctionComponent<Props> = ({ enableAbTesting }) => {
  const snippetUrl = `//cdn.optimizely.com/js/${OPTIMIZELY_ACCOUNT_ID}.js`;
  const enabled = OPTIMIZELY_ENABLED && enableAbTesting;
  const [areCookiesAllowed, setAreCookiesAllowed] = useState(false);

  useEffect(() => {
    const optanonConsent = Cookies.get("OptanonConsent");
    if (optanonConsent?.includes(allowedCookies)) {
      setAreCookiesAllowed(true);
    }

    window.addEventListener("OneTrustGroupsUpdated", (event) => {
      if ((event as unknown as {detail: string}).detail.includes(cookieCategory)) {
        setAreCookiesAllowed(true);
      } else {
        setAreCookiesAllowed(false);
      }
    });
  });

  return (
    enabled && areCookiesAllowed
      ? (
        <Helmet>
          <link rel="preload" href={snippetUrl} as="script" />
          <link rel="preconnect" href="//logx.optimizely.com" />
          <script src={snippetUrl} />
        </Helmet>
      )
      : null
  );
};
